<div tabindex="1" class="add-tip-popup">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h4 class="mg-btm-32">Add a Tip for Your Driver?</h4>
    </div>
  </div>
  <div class="row">
    <div class="select-amount">
      <span class="left">Select an amount -</span>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <div aria-orientation="horizontal" role="radiogroup" class="btn-group wab-btn-group" data-toggle="buttons">
        <label *ngFor="let item of standardOptions; let i = index" [ngClass]="getBtnActiveStyle(item)" (click)="toggleOtherValues('null',item)">
          <label for="tip_{{i}}"></label>
          <input .aria-label="${{item}}" id="tip_{{i}}" name="amount" [value]="amount" type="radio" [(ngModel)]="amount">
            ${{item}}
        </label>
          <div class="custom">
            <label [ngClass]="{'active': this.isOthersSelect}" class="btn btn-wab" (click)="toggleOtherValues('Custom', DEFAULT_TIP_VALUE)">
              <input aria-label="Other" id ="tip_custom" name="amount" [value]="amount" type="radio" [(ngModel)]="amount">
              Other
            </label> 
              <select class="form-control custom-select" *ngIf="isOthersSelect" [(ngModel)]="selectedTipValue" (change)="toggleOtherValues('Custom',selectedTipValue)">
                <option  *ngFor="let oa of otherAmounts" [ngValue]="oa" [attr.selected] = "oa == selectedTipValue ?  'selected': oa == DEFAULT_TIP_VALUE ? 'selected': null"> ${{oa}}</option>
            </select>
          </div>
      </div>
    </div>
  </div>
  <div class="row mg-top-32">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mg-top-24">
      <button type="submit" (click)='submitTip()' class="btn wb-btn-default center-block">Add Tip</button>
    </div>    
  </div>  